import WebhookDialog from './WebhookDialog';

export default WebhookDialog;
